import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from '@/components/ModalSheet'
import { Button } from '@/components/Button'

export interface CopyJobDialogProps {
  showing: boolean
  onClose: () => unknown
  onClone: () => unknown
  isClonePending: boolean
  confirmButtonTestId?: string
}

export function CopyJobDialog({
  showing,
  onClose,
  onClone,
  isClonePending,
  confirmButtonTestId,
}: CopyJobDialogProps) {
  return (
    <ModalSheet
      showing={showing}
      onRequestClose={isClonePending ? undefined : onClose}
    >
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>Clone Job</ModalSheetContentTitle>
          <ModalSheetContentDescription>
            A new request will be drafted (but not submitted) using the answers
            from this request.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Cancel"
            onPress={onClose}
            isDisabled={isClonePending}
          />
          <Button
            label="Clone"
            variant="primary"
            onPress={onClone}
            isPending={isClonePending}
            testId={confirmButtonTestId}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}
